import "../App.css";
import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Link } from "react-router-dom";
import Step1Email from "../components/Step1Email";
import Step2Address from "../components/Step2Address";
import Step3Review from "../components/Step3Review";
import Step4Payment from "../components/Step4Payment";
import OrderConfirmation from "../components/OrderConfirmation";
import ZinePlaceholder from "../assets/zinePlaceholder.jpeg";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function ZinePage() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [purchaseCompleted, setPurchaseCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [email, setEmail] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [shippingRate, setShippingRate] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [isOrderConfirmed, setIsOrderConfirmed] = useState(false);
  const [zineProduct, setZineProduct] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [address, setAddress] = useState({
    name: "",
    line1: "",
    city: "",
    country: "",
    postal_code: "",
  });
  useEffect(() => {
    async function fetchProducts() {
      try {
        const response = await fetch(`${API_BASE_URL}/products`);
        const data = await response.json();
        const newZineProduct = data.filter(
          (product) => product.metadata.zine === "true"
        );
        console.log("Zine Product:", newZineProduct);
        setZineProduct(newZineProduct[0]);
        // setZineProduct({});
      } catch (error) {
        console.error("Error fetching zine:", error);
      }
    }

    fetchProducts();
  }, []);

  const fetchShippingRate = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get-shipping-rate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address }),
      });
      const data = await response.json();
      setShippingRate(data.shippingRate);
    } catch (error) {
      console.error("Error fetching shipping rate:", error);
    }
  };

  async function fetchClientSecret() {
    console.log("Fetching client secret...");
    try {
      const response = await fetch(
        `${API_BASE_URL}/create-subscription-intent`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            priceId: zineProduct.prices[0].id,
            email: email,
            address: address,
          }),
        }
      );
      const { clientSecret } = await response.json();
      console.log("Received client secret:", clientSecret);
      setClientSecret(clientSecret);
    } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  }

  useEffect(() => {
    if (!showModal) return;
    fetchClientSecret();
  }, [showModal]);

  const options = clientSecret ? { clientSecret } : null;

  const handleNextStep = (step) => {
    if (step === 2 && !email.trim()) {
      setValidationErrors({ email: "Email is required" });
      return;
    }
    setValidationErrors({});
    setCurrentStep(step);
  };

  const validateAddress = () => {
    const errors = {};
    if (!address.name) errors.name = "Name is required";
    if (!address.line1) errors.line1 = "Address Line 1 is required";
    if (!address.city) errors.city = "City is required";
    if (!address.country) errors.country = "Country is required";
    if (!address.postal_code) errors.postal_code = "Postal Code is required";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGoToStep = (step) => {
    setCurrentStep(step);
  };

  const handleSubscribe = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentStep(1);
    setValidationErrors({});
  };

  const handleOrderConfirmed = () => {
    setIsOrderConfirmed(true);
    setShowModal(false);
  };

  console.log("zineProduct", !!zineProduct);
  const parseDescription = (text) =>
    text.split(/(\[\[.*?\]\])/g).map((part, i) =>
      part.startsWith("[[") && part.endsWith("]]") ? (
        <strong key={i} className="fw-bold">
          {part.slice(2, -2)}
        </strong>
      ) : (
        part
      )
    );
  return (
    <div className="ZinePage">
      {!zineProduct ? (
        <p>Loading Prints...</p>
      ) : (
        <div className="print-detail flex-column gap-0">
          <Link to={`/prints`}>
            <svg
              className="backIcon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
            </svg>
          </Link>
          <div className="print-detail">
            <div className="image-container ">
              <img
                src={
                  zineProduct.images ? zineProduct.images[0] : ZinePlaceholder
                }
                alt={zineProduct.name}
                className="print-image-detail"
              />
            </div>

            <div className="details-container">
              <h2 className="contact-title">{zineProduct.name}</h2>
              <p className="text-muted justifiedText fs-6">
                {parseDescription(zineProduct.description)}
              </p>
              <p className="price">
                £{zineProduct.prices[0].amount} / bianually
              </p>

              {!isOrderConfirmed && (
                <button onClick={handleSubscribe} className="add-to-cart-btn">
                  Subscribe
                </button>
              )}

              {isOrderConfirmed && <OrderConfirmation />}
            </div>
          </div>
        </div>
      )}

      {showModal && zineProduct && (
        <div className="checkout-modal-overlay">
          <div className="checkout-modal">
            <button className="close-modal-btn" onClick={handleCloseModal}>
              ×
            </button>

            <h3 className="modal-title">Subscribe to {zineProduct.name}</h3>

            <div className="checkout-flow">
              <Step1Email
                currentStep={currentStep}
                handleGoToStep={handleGoToStep}
                handleNextStep={handleNextStep}
                email={email}
                setEmail={setEmail}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <Step2Address
                currentStep={currentStep}
                handleGoToStep={handleGoToStep}
                handleNextStep={handleNextStep}
                address={address}
                setAddress={setAddress}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                validateAddress={validateAddress}
                fetchShippingRate={fetchShippingRate}
                fetchClientSecret={fetchClientSecret}
              />

              <Step3Review
                currentStep={currentStep}
                handleGoToStep={handleGoToStep}
                handleNextStep={handleNextStep}
                agreed={agreed}
                setAgreed={setAgreed}
                handlePurchase={handleOrderConfirmed}
              />
              <Step4Payment
                setPurchaseCompleted={setPurchaseCompleted}
                currentStep={currentStep}
                handleGoToStep={handleGoToStep}
                clientSecret={clientSecret}
                stripePromise={stripePromise}
                options={options}
                cartItems={cartItems}
                address={address}
                purchaseCompleted={purchaseCompleted}
                email={email}
                setCartItems={setCartItems}
                isSubscription
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ZinePage;
